import React from 'react';
import MainRoutes from './routes/MainRoutes';
import '../src/assets/css/App.css';

const App = () => <MainRoutes />;

export default App;
